import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { htmlPreviewStyle } from './HtmlPreview.css';

type Props = Omit<ComponentPropsWithRef<'iframe'>, 'sandbox' | 'src' | 'srcDoc'> & {
  html: string;
  title: string;
};

export const HtmlPreview = ({ html, title, ...delegated }: Props) => {
  return <iframe {...delegated} className={clsx(htmlPreviewStyle, delegated.className)} sandbox="" srcDoc={html} title={title} />;
};
